<p>verify-information-external-link works!</p>
